import commonStore from '../store/common';

export const isCellEmpty = (value: unknown): boolean =>
  value === '' || value === undefined || value === null;

export type CellState = {
  isInvalid: boolean;
  isReadOnly: boolean;
  isStaticOverride: boolean;
  isDisabled: boolean;
  background: string;
};

export const getCellState = (cell: any, isEmptyValue: boolean): CellState => {
  const isInvalid = (isEmptyValue && cell.required) || !!cell.errorMessage;
  const isReadOnly = commonStore.isViewer || cell.nonEditable || cell.isSectionDisabled;
  const isStaticOverride = !cell.isStaticTemplate && cell.isStaticField;
  const isDisabled = isStaticOverride || isReadOnly;
  const hasDifference = !!cell?.difference?.is_changed;

  const background = isInvalid
    ? '#FFF5F5'
    : cell.isSectionDisabled || (isDisabled && !hasDifference)
      ? '#F8F9FA'
      : '#fff';

  return { isInvalid, isReadOnly, isStaticOverride, isDisabled, background };
};
